// The API stores daily dose times, not the portal's frequency template selection.
export const getDailyScheduleFrequency = offsets => {
  if (offsets?.length === 6) {
    const sorted = [...offsets].sort((a, b) => a - b);
    const everyFourHours = sorted.every((offset, index) =>
      (sorted[(index + 1) % sorted.length] - offset + 86400) % 86400 === 14400,
    );
    return everyFourHours ? 'everyFourHours' : 'sixTimesDaily';
  }
  return {
    1: 'onceDaily',
    2: 'twiceDaily',
    3: 'threeTimesDaily',
    4: 'fourTimesDaily',
    5: 'fiveTimesDaily',
  }[offsets?.length];
};
